import { hasValue } from "utilities/common";

export function templateKitValidation(fields) {
    const myErrors = {}

    if (!fields.regionId) {
        myErrors.regionId = 'Please select a region'
    }
    if (!fields.subRegionId || !fields?.subRegionId?.length) {
        myErrors.subRegionId = 'Please select a sub region'
    }
    if (fields.minProductPerRegion && fields.maxProductPerRegion && Number(fields.maxProductPerRegion) < Number(fields.minProductPerRegion)) {
        myErrors.maxProductPerRegion = 'Maximum product per region must be greater than minimum product'
    }

    myErrors.boxes = myErrors.boxes || [];

    for (const i in fields.boxes) {
        const box = fields.boxes[i]

        myErrors.boxes[i] = { ...(myErrors.boxes[i] || {}) };

        if (box.minProductValuePerBox && box.maxProductValuePerBox && Number(box.maxProductValuePerBox) < Number(box.minProductValuePerBox)) {
            myErrors.boxes[i].maxProductValuePerBox = 'Maximum product per region must be greater than minimum product'
        }
    }

    return { myErrors, isValid: !hasValue(myErrors) };
}